@if (invoiceResult$ | async; as invoiceResult) {
  <div class="results-section">
    @if (sorts$ | async; as sorts) {
      <div class="results-header">
        @if (paginate$ | async; as paginate) {
          <div class="results-info">
            <kn-br-browsing [paginate]="paginate" [recordsShown]="invoiceResult.length"
              recordType="{{ 'label.invoices' | cxTranslate }}">
            </kn-br-browsing>
          </div>
        }
        <div class="results-actions">
          <label class="sort-label">Sort By</label>
          <cx-sorting [sortOptions]="sorts" [sortLabels]="getSortLabels() | async"
            (sortListEvent)="changeSortCode($event)" [selectedOption]="sortType"
            placeholder="{{ 'invoiceResult.sortByMostRecent' | cxTranslate }}">
          </cx-sorting>
          @if (documentNumbers.length) {
            <button type="button" class="download-btn"
              (click)="downloadPdfOrNavigateToDetails(true)">
              {{ 'invoiceResult.header.downloadPDF' | cxTranslate }} &nbsp;
            </button>
          }
          <button type="button" class="download-btn" [disabled]="downloadProgress" (click)="downloadInvoice()">
            {{ 'invoiceResult.header.downloadStatement' | cxTranslate }}
          </button>
        </div>
      </div>
    }
    <!-- INVOICES TABLE -->
    @if (invoiceResult && invoiceResult.length) {
      <table class="invoices-table">
        <thead>
          <tr>
            <th></th>
            <th>{{ 'invoiceResult.header.documentType' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.customerNumber' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.soldToCity' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.purchaseOrder' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.jobName' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.document' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.documentDate' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.amount' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.dueDate' | cxTranslate }}</th>
            <th>{{ 'invoiceResult.header.status' | cxTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (invoice of this.invoiceList; track invoice) {
            <tr>
              <td><input type="checkbox" class="invoice-checkbox" (change)="select(invoice, $event.target.checked)" [checked]="this.documentNumbers.includes(invoice.documentNumber)"></td>
              <td>{{ invoice.documentType?.name }}</td>
              <td>{{ invoice?.accountNumber }}</td>
              <td>{{ invoice?.city }}</td>
              <td (click)="downloadPdfOrNavigateToDetails(false, invoice)">{{ invoice.purchaseOrder }}</td>
              <td (click)="downloadPdfOrNavigateToDetails(false, invoice)">{{ invoice.jobName ? invoice.jobName: '-' }}</td>
              <td (click)="downloadPdfOrNavigateToDetails(false, invoice)"><a href="javascript:void(0)" class="invoice-link"> {{ invoice.documentNumber | removeLeadingZeros }}</a></td>
              <td  (click)="downloadPdfOrNavigateToDetails(false, invoice)"> {{ invoice.invoiceDate }}</td>
              <td class="currency" (click)="downloadPdfOrNavigateToDetails(false, invoice)">{{ invoice.formattedAmount }}</td>
              <td (click)="downloadPdfOrNavigateToDetails(false, invoice)">{{ invoice.knbrDueDate }}</td>
              <td (click)="downloadPdfOrNavigateToDetails(false, invoice)"><span class="status-text">{{ invoice.status | titlecase }}</span></td>
            </tr>
          }
        </tbody>
      </table>
    }
    <!-- SHOW MORE BUTTON -->
    <div class="show-more-container">
      @if (paginate$ | async; as paginate) {
        <button class="show-more-btn" (click)="loadMore(paginate.currentPage)">
          {{ 'invoiceResult.showMore' | cxTranslate }}
        </button>
      }
    </div>
    @if (invoiceResult && invoiceResult.length < 1 && !(isLoader$ | async)) {
      <div class="alert-info p-3 rounded mt-3">
        {{ 'invoiceResult.nodataMsg' | cxTranslate }}
      </div>
    }
  </div>
}